import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E1",
    // audio: "/Audios/1-04 Friends Plus 8_WB.mp3",
    video: "",
    component: T6v2,
    inputSize:350,
    exerciseKey: "/img/FriendsPlus/Page12/Key/E1answerKey.jpg",
    titleQuestion: [
      {
        title: ` <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">4</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Trong các số dưới đây, số nào là số chẵn, số nào là số lẻ?</div>
      </div>`
      },
    ],
    questions: [
      {
        title: `
        <img src="/img/FriendsPlus/Page12/E1/1.jpg" Style='width:80%;margin-left:50px' >
        <div style='line-height:3.5;margin-left:40px;margin-top:40px'>
        <div> <b>a) Số chẵn là:</b> #</div>

        <div> <b>b) Số lẻ là:</b> #</div>
        
        </div>
        `,
        answer: [
          `12, 108, 194, 656, 72`,`315, 71, 649, 113, 107`,
        ],
      },
    ],
  },
  2: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E2",
    audio: "",
    video: "",
    component:T6v2,
    exerciseKey: "/img/FriendsPlus/Page12/Key/E2answerKey.jpg",
    titleQuestion: [
      {
        // num: "2",
        // title: `Read the timeline again. Choose the 
        // correct words to describe each paragraph.`,
        // color: "rgb(218,43,55)",
        // star:2
      },
    ],
    questions: [
      {
        title: `
        <img src="/img/FriendsPlus/Page12/E2/1.jpg" Style='width:90%;margin:auto' >
        `,
        answer: [
          "",
        ],
      },
    ],
  },
 
};

export default json;
